/* eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";

import {
	Row,
	Col,
	CardBody,
	Card,
	Alert,
	Container,
	Form,
	Input,
	FormFeedback,
	Label,
	Button,
	CardTitle,
	FormGroup,
	Spinner,
} from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import { useNavigate } from "react-router-dom";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

//Social Media Imports
// import { GoogleLogin } from "react-google-login";
// import TwitterLogin from "react-twitter-auth"
// import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";

// actions
import { loginUser, socialLogin } from "../../store/actions";

// import images
import profile from "assets/images/profile-img.png";
import logo from "assets/images/logo.svg";

//Import config
// import { facebook, google } from "../../config";
import { LogoSendaSVG } from "../../assets/svg/icon";
import authService from "services/AuthService";
import ModalNovaSenha from "./modal-nova-senha";
import ModalAlterarSenha from "./modal-alterar-senha";
import Swal from "sweetalert2";
import { Checkbox } from "@mui/material";
import { CheckSquare, Square } from "@phosphor-icons/react";
import loginQuotesService from "services/LoginQuotesService";
import { SendaCustomSwal } from "components/Common/SendaCustomSwal";
import loginImagesService from "services/LoginImagesService";

const Login = (props) => {
	//meta title
	document.title = "Método Senda";

	const dispatch = useDispatch();
	const navigate = useNavigate();

	const [modalOpen, setModalOpen] = useState(false);
	const [modalAlterarSenhaOpen, setModalAlterarSenhaOpen] = useState(false);
	const [emailParam, setEmailParam] = useState("");
	const [isLoading, setIsLoading] = useState(false);
	const [randomQuote, setRandomQuote] = useState({ quote: "", author: "" });
	const [randomLoginImage, setRandomLoginImage] = useState({ name: "" });
	const [isImageLoading, setIsImageLoading] = useState(true);

	const toggleModal = () => {
		setModalOpen(!modalOpen);
	};

	const toggleModalAlterarSenha = () => {
		setModalAlterarSenhaOpen(!modalAlterarSenhaOpen);
	};

	const validation = useFormik({
		// enableReinitialize : use this flag when initial values needs to be changed
		enableReinitialize: true,

		initialValues: {
			email: "",
			password: "",
		},
		validationSchema: Yup.object({
			email: Yup.string().required("Please Enter Your Email"),
			password: Yup.string().required("Please Enter Your Password"),
		}),
		onSubmit: async (values) => {
			try {
				setIsLoading(true);
				const response = await authService.post({
					email: values.email,
					password: values.password,
				});
				localStorage.setItem("authUser", JSON.stringify(response));
				
				// Salvar company_id (pode ser null se usuário tem múltiplas empresas)
				const companyId = response.user.company_id || "null";
				localStorage.setItem("company_id", companyId);
				
				// Sempre vai para dashboard
				// Se company_id for null, dashboard ficará vazio
				navigate("/dashboard");
			} catch (error) {
				if (
					error?.response?.status === 403 &&
					error?.response?.data?.password_change_required === true
				) {
					// Usuário precisa alterar senha temporária
					SendaCustomSwal.fire({
						title: "Atenção!",
						text: "Você está utilizando uma senha temporária. Por favor, altere sua senha para continuar.",
						iconHtml: '<i class="warning-icon"></i>',
						confirmButtonText: "Ok",
						customClass: {
							confirmButton: "custom-confirm-button",
						},
					}).then((result) => {
						if (result.isConfirmed) {
							SendaCustomSwal.close();
							setEmailParam(values.email);
							toggleModalAlterarSenha();
						}
					});
				} else if (
					error?.response?.status === 401 &&
					error?.response?.data?.new_password_required === true
				) {
					//criar um swal dizendo q foi enviado um email com um codigo para criar uma nova senha, ao clica em ok, abrir o modal
					SendaCustomSwal.fire({
						title: "Atenção!",
						text: "Foi enviado um email com um código para criar uma nova senha.",
						iconHtml: '<i class="warning-icon"></i>',
						confirmButtonText: "Ok",
						customClass: {
							confirmButton: "custom-confirm-button",
						},
					}).then((result) => {
						if (result.isConfirmed) {
							SendaCustomSwal.close();
							setEmailParam(values.email);
							toggleModal();
						}
					});
				}
			} finally {
				setIsLoading(false);
			}
		},
	});

	const { error } = useSelector((state) => ({
		error: state.Login.error,
	}));

	useEffect(() => {
		const getQuotes = async () => {
			try {
				const response = await loginQuotesService.get();

				if (response.length > 0) {
					const randomQuote =
						response[Math.floor(Math.random() * response.length)];

					setRandomQuote(randomQuote);
				}
			} catch (error) {
				console.log("Erro ao buscar citações: ", error);
			}
		};

		const getRandomImage = async () => {
			try {
				const response = await loginImagesService.getRandomImage();
				setRandomLoginImage(response);
			} catch (error) {
				console.log("Erro ao buscar imagem: ", error);
			} finally {
				setIsImageLoading(false);
			}
		};
		getQuotes();
		getRandomImage();
	}, []);

	// const signIn = (res, type) => {
	//   if (type === "google" && res) {
	//     const postData = {
	//       name: res.profileObj.name,
	//       email: res.profileObj.email,
	//       token: res.tokenObj.access_token,
	//       idToken: res.tokenId,
	//     };
	//     dispatch(socialLogin(postData, props.router.navigate, type));
	//   } else if (type === "facebook" && res) {
	//     const postData = {
	//       name: res.name,
	//       email: res.email,
	//       token: res.accessToken,
	//       idToken: res.tokenId,
	//     };
	//     dispatch(socialLogin(postData, props.router.navigate, type));
	//   }
	// };

	// //handleGoogleLoginResponse
	// const googleResponse = response => {
	//   signIn(response, "google");
	// };

	// //handleTwitterLoginResponse
	// // const twitterResponse = e => {}

	// //handleFacebookLoginResponse
	// const facebookResponse = response => {
	//   signIn(response, "facebook");
	// };

	return (
		<React.Fragment>
			<ModalNovaSenha
				isOpen={modalOpen}
				toggle={toggleModal}
				email={emailParam}
			/>
			<ModalAlterarSenha
				isOpen={modalAlterarSenhaOpen}
				toggle={toggleModalAlterarSenha}
				email={emailParam}
			/>
			<div className="home-btn d-none d-sm-block">
				<Link to="/" className="text-dark">
					<i className="bx bx-home h2" />
				</Link>
			</div>
			<Container fluid className="vh-100  p-0">
				<Row className="w-100 h-100 m-0">
					<Col
						md="4"
						className="d-flex align-items-center justify-content-center bg-light"
					>
						<Card
							className="border-0 shadow-sm"
							style={{ maxWidth: "400px", width: "100%" }}
						>
							<div style={{ padding: 35, textAlign: "center" }}>
								<LogoSendaSVG />
							</div>
							<CardBody className="pt-0">
								<div>
									<Link to="/" className="logo-light-element">
										<div className="avatar-md profile-user-wid mb-4">
											<span className="avatar-title rounded-circle bg-light">
												<img
													src={logo}
													alt=""
													className="rounded-circle"
													height="34"
												/>
											</span>
										</div>
									</Link>
								</div>
								<div className="p-2">
									<Form
										className="form-horizontal"
										onSubmit={(e) => {
											e.preventDefault();
											validation.handleSubmit();
											return false;
										}}
									>
										{error ? (
											<Alert color="danger">
												{error}
											</Alert>
										) : null}

										<div className="mb-3">
											<Label className="form-label">
												Email
											</Label>
											<Input
												name="email"
												className="form-control"
												placeholder="Enter email"
												type="email"
												onChange={
													validation.handleChange
												}
												onBlur={validation.handleBlur}
												value={
													validation.values.email ||
													""
												}
												invalid={
													validation.touched.email &&
													validation.errors.email
														? true
														: false
												}
											/>
											{validation.touched.email &&
											validation.errors.email ? (
												<FormFeedback type="invalid">
													{validation.errors.email}
												</FormFeedback>
											) : null}
										</div>

										<div className="mb-3">
											<Label className="form-label">
												Senha
											</Label>
											<Input
												name="password"
												value={
													validation.values
														.password || ""
												}
												type="password"
												placeholder="Enter Password"
												onChange={
													validation.handleChange
												}
												onBlur={validation.handleBlur}
												invalid={
													validation.touched
														.password &&
													validation.errors.password
														? true
														: false
												}
											/>
											{validation.touched.password &&
											validation.errors.password ? (
												<FormFeedback type="invalid">
													{validation.errors.password}
												</FormFeedback>
											) : null}
										</div>

										<div
											className="form-check"
											style={{
												display: "flex",
												justifyContent: "flex-end",
												alignItems: "center",
											}}
										>
											<Checkbox
												className="form-check-input"
												id="customControlInline"
												style={{
													background: "none",
													border: "none",
													padding: 0,
													cursor: "pointer",
													color: "black",
													marginRight: 5,
													fontSize: 16,
												}}
												icon={<Square />}
												checkedIcon={<CheckSquare />}
											/>
											<label
												className="form-check-label"
												htmlFor="customControlInline"
											>
												Me lembre
											</label>
										</div>
										<div>
											<a
												onClick={() =>
													SendaCustomSwal.fire({
														title: "Digite seu email",
														input: "email",
														showCancelButton: true,
														confirmButtonText:
															"Enviar",
														cancelButtonText:
															"Cancelar",
														showLoaderOnConfirm: true,
														customClass: {
															cancelButton:
																"custom-cancel-button",
															confirmButton:
																"custom-confirm-button",
														},
														preConfirm: async (
															email,
														) => {
															const response =
																await authService.verifyEmail(
																	email,
																);
															if (
																response.success ===
																true
															) {
																await authService.sendMailToResetPwd(
																	email,
																);
																SendaCustomSwal.fire(
																	{
																		title: "Atenção!",
																		text: "Foi enviado um email com um código para criar uma nova senha.",
																		iconHtml:
																			'<i class="warning-icon"></i>',
																		confirmButtonText:
																			"Ok",
																		customClass:
																			{
																				confirmButton:
																					"custom-confirm-button",
																			},
																	},
																).then(
																	(
																		result,
																	) => {
																		if (
																			result.isConfirmed
																		) {
																			SendaCustomSwal.close();
																			setEmailParam(
																				email,
																			);
																			toggleModal();
																		}
																	},
																);
															}
														},
														allowOutsideClick: () =>
															!SendaCustomSwal.isLoading(),
													})
												}
												style={{
													cursor: "pointer",
													color: "#6c757d",
													display: "flex",
													justifyContent: "center",
													alignItems: "center",
													alignContent: "center",
													marginTop: 5,
												}}
											>
												Esqueci minha senha
											</a>
										</div>
										<div className="mt-3 d-grid">
											<Button
												style={{
													background: "none",
													padding: 10,
													cursor: "pointer",
													color: "black",
													display: "flex",
													alignItems: "center",
													justifyContent: "center",
												}}
												type="submit"
												disabled={isLoading}
											>
												{isLoading ? (
													<span
														className="spinner-border spinner-border-sm mr-1"
														style={{
															marginRight: 10,
														}}
													></span>
												) : null}
												Entrar
											</Button>
										</div>

										<div className="mt-4 text-center">
											{/* <h5 className="font-size-14 mb-3">Ou entre com</h5>

	                    <ul className="list-inline">
	                      <li className="list-inline-item">
	                        <FacebookLogin
	                          appId={facebook.APP_ID}
	                          autoLoad={false}
	                          callback={facebookResponse}
	                          render={renderProps => (
	                            <Link
	                              to="#"
	                              className="social-list-item bg-primary text-white border-primary"
	                              onClick={renderProps.onClick}
	                            >
	                              <i className="mdi mdi-facebook" />
	                            </Link>
	                          )}
	                        />
	                      </li> */}
											{/*<li className="list-inline-item">*/}
											{/*  <TwitterLogin*/}
											{/*    loginUrl={*/}
											{/*      "http://localhost:4000/api/v1/auth/twitter"*/}
											{/*    }*/}
											{/*    onSuccess={this.twitterResponse}*/}
											{/*    onFailure={this.onFailure}*/}
											{/*    requestTokenUrl={*/}
											{/*      "http://localhost:4000/api/v1/auth/twitter/revers"*/}
											{/*    }*/}
											{/*    showIcon={false}*/}
											{/*    tag={"div"}*/}
											{/*  >*/}
											{/*    <a*/}
											{/*      href=""*/}
											{/*      className="social-list-item bg-info text-white border-info"*/}
											{/*    >*/}
											{/*      <i className="mdi mdi-twitter"/>*/}
											{/*    </a>*/}
											{/*  </TwitterLogin>*/}
											{/*</li>*/}
											{/* <li className="list-inline-item">
	                        <GoogleLogin
	                          clientId={google.CLIENT_ID}
	                          render={renderProps => (
	                            <Link
	                              to="#"
	                              className="social-list-item bg-danger text-white border-danger"
	                              onClick={renderProps.onClick}
	                            >
	                              <i className="mdi mdi-google" />
	                            </Link>
	                          )}
	                          onSuccess={googleResponse}
	                          onFailure={() => { }}
	                        />
	                      </li>
	                    </ul> */}
										</div>

										<div className="mt-4 text-center">
											{/* <Link to="/forgot-password" className="text-muted">
	                      <i className="mdi mdi-lock me-1" />
	                      Esqueceu a sua senha?
	                    </Link> */}
										</div>
									</Form>
								</div>
							</CardBody>
						</Card>
						{/* <div className="mt-5 text-center">
	            <p>
	              Ainda não tem uma conta ?{" "}
	              <Link to="/register" className="fw-medium text-primary">
	                {" "}
	                Cadastre-se agora{" "}
	              </Link>{" "}
	            </p>
	          </div> */}
					</Col>
					<Col
						md="8"
						className="d-none d-md-flex bg-black align-items-center justify-content-center"
						style={{
							height: "100vh",
							padding: 0,
							overflow: "hidden",
							position: "relative",
						}}
					>
						{isImageLoading ? (
							<div
								style={{
									position: "absolute",
									top: 0,
									left: 0,
									width: "100%",
									height: "100%",
									backgroundColor: "#fff",
									display: "flex",
									justifyContent: "center",
									alignItems: "center",
									zIndex: 10,
								}}
							>
								<Spinner
									style={{ width: "3rem", height: "3rem" }}
									color="primary"
								/>
							</div>
						) : (
							randomLoginImage && (
								<img
									src={randomLoginImage.name || "https://dimo.nyc3.digitaloceanspaces.com/senda_homolog/0f6ec604-99d4-4feb-bdd1-8a6d6067c013.jpg"}
									alt="Imagem do Login"
									className="img-fluid"
									style={{
										width: "100%",
										height: "100%",
										objectFit: "cover",
									}}
								/>
							)
						)}
						<div
							className="position-absolute text-white text-center"
							style={{
								bottom: "20px",
								left: "50%",
								transform: "translateX(-50%)",
								fontSize: "1.2rem",
								maxWidth: "80%",
								lineHeight: "1.6",
							}}
						>
							{randomQuote.quote && (
								<p>
									"{randomQuote.quote}" -{" "}
									<strong>{randomQuote.author}</strong>
								</p>
							)}
						</div>
					</Col>
				</Row>
			</Container>
		</React.Fragment>
	);
};

export default withRouter(Login);
